import React, { useCallback, useState } from 'react';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Card } from '@tmap/mmm-style-guide/src/Card';
import { Chip } from '@tmap/mmm-style-guide/src/Chip';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Hyperlink } from '@tmap/mmm-style-guide/src/Hyperlink';
import { ThemeProvider } from '@tmap/mmm-style-guide/src/Theming';
import locationLabelText from '@tmap/mmm-core/locationLabelText';

import ColorBlocks from '../../layouts/colorBlocks';
import IncentiveCard from '../incentiveCard/index';
import { LIGHT_THEME } from '../../lib/themes';

const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  background: theme.palette.common.white,
  cursor: 'pointer',
  padding: '23px',
  borderRadius: '7px',
}));

const LocationChip = styled(Chip)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.secondary.light,
}));

function OffersHeader(props) {
  const [isTextVisible, setTextVisible] = useState(false);

  const {
    entity,
    leadText,
  } = props;

  const {
    locationText,
    regionText,
    featuredDescription,
    longDescription,
  } = entity;

  const description = featuredDescription || longDescription || '';
  const sentenceBreak = description.indexOf('. ', 180) + 1;
  const firstDescription = description.slice(0, sentenceBreak);
  const secondDescription = description.slice(sentenceBreak).trim();

  const showText = useCallback(() => setTextVisible(true), []);
  const hideText = useCallback(() => setTextVisible(false), []);

  return (
    <ColorBlocks.Block color='dark'>
      <Grid container direction='row' spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant='h4' component='h1' color='textPrimary' sx={{ marginBottom: 3, fontWeight: 600 }}>
            {leadText}
          </Typography>
          <LocationChip
            variant='pill'
            size='small'
            label={locationLabelText(locationText, regionText)}
          />
          <Typography variant='body2' color='textSecondary'>{firstDescription}</Typography>
          {secondDescription && (
            <>
              <Typography variant='body2' color='textSecondary' sx={{ marginTop: 1, display: { xs: 'none', md: 'block' } }}>
                {secondDescription}
              </Typography>
              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                {isTextVisible && (
                  <>
                    <Typography variant='body2' color='textSecondary' sx={{ marginTop: 1 }}>{secondDescription}</Typography>
                    <Hyperlink component='button' variant='body2' onClick={hideText} sx={{ color: (t) => t.palette.secondary.light }}>Hide</Hyperlink>
                  </>
                )}
                {!isTextVisible && (
                  <Hyperlink
                    component='button'
                    variant='body2'
                    sx={{ color: (theme) => theme.palette.secondary.light, display: {} }}
                    onClick={showText}
                  >View More
                  </Hyperlink>
                )}
              </Box>
            </>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledCard>
            <ThemeProvider theme={LIGHT_THEME}>
              <IncentiveCard incentive={entity} variant='contained' color='secondary' placementId='exploreOffersHero' pageId='exploreOffers' />
            </ThemeProvider>
          </StyledCard>
        </Grid>
      </Grid>
    </ColorBlocks.Block>
  );
}

export default OffersHeader;
